/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TerminateOfferRequest
 */
export interface TerminateOfferRequest {
    /**
     * 
     * @type {Date}
     * @memberof TerminateOfferRequest
     */
    terminationStateOn: Date;
    /**
     * 
     * @type {Date}
     * @memberof TerminateOfferRequest
     */
    terminationOn: Date;
}

/**
 * Check if a given object implements the TerminateOfferRequest interface.
 */
export function instanceOfTerminateOfferRequest(value: object): value is TerminateOfferRequest {
    if (!('terminationStateOn' in value) || value['terminationStateOn'] === undefined) return false;
    if (!('terminationOn' in value) || value['terminationOn'] === undefined) return false;
    return true;
}

export function TerminateOfferRequestFromJSON(json: any): TerminateOfferRequest {
    return TerminateOfferRequestFromJSONTyped(json, false);
}

export function TerminateOfferRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminateOfferRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'terminationStateOn': (new Date(json['terminationStateOn'])),
        'terminationOn': (new Date(json['terminationOn'])),
    };
}

export function TerminateOfferRequestToJSON(json: any): TerminateOfferRequest {
    return TerminateOfferRequestToJSONTyped(json, false);
}

export function TerminateOfferRequestToJSONTyped(value?: TerminateOfferRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'terminationStateOn': ((value['terminationStateOn']).toISOString()),
        'terminationOn': ((value['terminationOn']).toISOString()),
    };
}

